import Dashboard from "./views/Dashboard";
import Login from "./views/Login";
// Our views
import TasksList from "./views/TasksList";
import MyTasksList from "./views/MyTasksList";
import TasksCreate from "./views/TasksCreate";
import TasksDetail from "./views/TasksDetail";
import ApproveTaskDetail from "./views/ApproveTaskDetail";
import MyTaskDetail from "./views/MyTaskDetail";
import RolesPage from "./views/RolesPage";
import UsersListPage from "./views/UsersListPage ";
import UserDetailPage from "./views/UserDetailPage ";
import ProfileDashboard from "./views/Profile";
import ForbiddenPage from "./views/ForbiddenPage";
import TasksListCreated from "./views/TasksListCreated";
// Dashboard and Analytics views
import AdminDashboard from "./views/AdminDashboard";
import UserDashboard from "./views/UserDashboard";
import AnalyticsPage from "./views/AnalyticsPage";
// Event views
import EventsList from "./views/EventsList";
import MyEvents from "./views/MyEvents";
import EventCreate from "./views/EventCreate";
import EventDetail from "./views/EventDetail";
// import EventEdit from "./views/EventEdit";
import TaskReviewPage from "./views/TaskReviewPage";
import MyReviewsPage from "./views/MyReviewsPage";
import EventEdit from "./views/EventEdit";
// Daily Todo views
import TodayTodoList from "./views/TodayTodoList";
import AdminCreateTodo from "./views/AdminCreateTodo";
// Admin views
import AdminUserTasks from "./views/AdminUserTasks";
// Legal views
import PrivacyPolicy from "./views/PrivacyPolicy";
import TermsOfService from "./views/TermsOfService";
// Notification views
import NotificationsList from "./views/NotificationsList";
import NotificationSettings from "./views/NotificationSettings";
import TestNotification from "./views/TestNotification";

const routes = [
    {
        path: "/",
        component: Dashboard,
    },
    {
        path: "/dashboard",
        component: Dashboard,
    },

    {
        route: "/login",
        component: Login,
    },

    // Our routes
    {
        path: "/tasks/list",
        component: TasksList,
    },
    {
        path: "/my-tasks/list",
        component: MyTasksList,
    },
    {
        path: "/tasks/create",
        component: TasksCreate,
    },
    {
        path: "/tasks/detail/:id",
        component: TasksDetail,
    },
    {
        path: "/tasks/approve-detail/:id",
        component: ApproveTaskDetail,
    },
    {
        path: "/tasks/my-detail/:id",
        component: MyTaskDetail,
    },
    {
        path: "/tasks/review",
        component: TaskReviewPage,
    },
    {
        path: "/my-reviews",
        component: MyReviewsPage,
    },
    {
        path: "/roles",
        component: RolesPage
    },
    {
        path: "/users",
        component: UsersListPage
    },
    {
        path: "/users/:userId",
        component: UserDetailPage
    },

    {
        path: "/profile",
        component: ProfileDashboard
    },

    {
        path: "/created/tasks/all",
        component: TasksListCreated
    },

    // Dashboard and Analytics routes
    // {
    //     path: "/dashboard/admin",
    //     component: AdminDashboard
    // },
    {
        path: "/dashboard/user",
        component: UserDashboard
    },
    {
        path: "/analytics",
        component: AnalyticsPage
    },

    // Event routes
    {
        path: "/events",
        component: MyEvents
    },
    {
        path: "/events/all",
        component: EventsList
    },
    {
        path: "/events/create",
        component: EventCreate
    },
    {
        path: "/events/detail/:id",
        component: EventDetail
    },
    {
        path: "/events/edit/:id",
        component: EventEdit
    },

    // Daily Todo routes
    {
        path: "/daily-todos/today",
        component: TodayTodoList
    },
    {
        path: "/admin/daily-todos/create",
        component: AdminCreateTodo
    },

    // Admin routes
    {
        path: "/admin/users/:userId/tasks",
        component: AdminUserTasks
    },

    // Notification routes
    {
        path: "/admin/notifications",
        component: NotificationsList
    },
    {
        path: "/admin/notifications/settings",
        component: NotificationSettings
    },
    {
        path: "/admin/notifications/test",
        component: TestNotification
    },

    // Legal routes (public pages - no layout)
    {
        route: "/privacy-policy",
        component: PrivacyPolicy
    },
    {
        route: "/terms-of-service",
        component: TermsOfService
    }

];

export default routes;

